module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M14.496 20.24l-5.284-6.326a.88.88 0 0 1 .192-1.234l1.432-1.042a.892.892 0 0 1 1.238.194l3.716 4.184L26.28 4.418a.891.891 0 0 1 1.238.194l1.046 1.43a.882.882 0 0 1-.192 1.234l-12.638 13.16a.893.893 0 0 1-1.238-.196z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/certification-highlight.js
// module id = 1052
// module chunks = 14